import { blend, clamp } from './interpolate';

const scoreHhi = (hhi) => {
  if (hhi <= 0.05) return 75;
  if (hhi <= 0.1) return 75 - ((hhi - 0.05) / 0.05) * (75 - 55);
  if (hhi <= 0.15) return 55 - ((hhi - 0.1) / 0.05) * (55 - 40);
  if (hhi <= 0.25) return 40 - ((hhi - 0.15) / 0.1) * (40 - 25);
  return clamp(25 - (hhi - 0.25) * 30, 10, 25);
};

const scoreTop5 = (share) => {
  if (share <= 0.25) return 80;
  if (share <= 0.4) return 80 - ((share - 0.25) / 0.15) * (80 - 55);
  if (share <= 0.6) return 55 - ((share - 0.4) / 0.2) * (55 - 30);
  return clamp(30 - (share - 0.6) * 40, 10, 30);
};

const scoreStickiness = (ratio) => clamp(25 + ratio * 55, 0, 85);

export const scoreD3 = (inputs) => {
  const recurringRatio = inputs.activeBuyers > 0 ? inputs.recurringBuyers / inputs.activeBuyers : 0;
  const hhi = scoreHhi(inputs.hhi);
  const top5 = scoreTop5(inputs.top5Share);
  const stickiness = scoreStickiness(recurringRatio);

  const score = blend([
    { score: hhi, weight: 0.45 },
    { score: top5, weight: 0.3 },
    { score: stickiness, weight: 0.25 },
  ]);

  return { score, subScores: { hhi, top5, stickiness } };
};
